import React, { useRef, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "antd";
import { fetchCustomerById, updateCustomerProfile } from "../../../redux/customer/customerSlice";
import axiosInstance from "../../../api/axiosInstance";
import { API_URLS } from "../../../api/apiUrls";
import { useLocation } from "react-router-dom";
import { ReactComponent as EditIcon } from "../../../assets/svgs/editButton.svg";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";

const countries = [
  { label: "Afghanistan", value: "Afghanistan" },
  { label: "Albania", value: "Albania" },
  { label: "Algeria", value: "Algeria" },
  { label: "Andorra", value: "Andorra" },
  { label: "Angola", value: "Angola" },
  { label: "Antigua and Barbuda", value: "Antigua and Barbuda" },
  { label: "Argentina", value: "Argentina" },
  { label: "Armenia", value: "Armenia" },
  { label: "Australia", value: "Australia" },
  { label: "Austria", value: "Austria" },
  { label: "Azerbaijan", value: "Azerbaijan" },
  { label: "Bahamas", value: "Bahamas" },
  { label: "Bahrain", value: "Bahrain" },
  { label: "Bangladesh", value: "Bangladesh" },
  { label: "Barbados", value: "Barbados" },
  { label: "Belarus", value: "Belarus" },
  { label: "Belgium", value: "Belgium" },
  { label: "Belize", value: "Belize" },
  { label: "Benin", value: "Benin" },
  { label: "Bhutan", value: "Bhutan" },
  { label: "Bolivia", value: "Bolivia" },
  { label: "Bosnia and Herzegovina", value: "Bosnia and Herzegovina" },
  { label: "Botswana", value: "Botswana" },
  { label: "Brazil", value: "Brazil" },
  { label: "Brunei", value: "Brunei" },
  { label: "Bulgaria", value: "Bulgaria" },
  { label: "Burkina Faso", value: "Burkina Faso" },
  { label: "Burundi", value: "Burundi" },
  { label: "Cabo Verde", value: "Cabo Verde" },
  { label: "Cambodia", value: "Cambodia" },
  { label: "Cameroon", value: "Cameroon" },
  { label: "Canada", value: "Canada" },
  { label: "Central African Republic", value: "Central African Republic" },
  { label: "Chad", value: "Chad" },
  { label: "Chile", value: "Chile" },
  { label: "China", value: "China" },
  { label: "Colombia", value: "Colombia" },
  { label: "Comoros", value: "Comoros" },
  { label: "Congo (Congo-Brazzaville)", value: "Congo (Congo-Brazzaville)" },
  { label: "Costa Rica", value: "Costa Rica" },
  { label: "Croatia", value: "Croatia" },
  { label: "Cuba", value: "Cuba" },
  { label: "Cyprus", value: "Cyprus" },
  { label: "Czechia", value: "Czechia" },
  { label: "Democratic Republic of the Congo", value: "Democratic Republic of the Congo" },
  { label: "Denmark", value: "Denmark" },
  { label: "Djibouti", value: "Djibouti" },
  { label: "Dominica", value: "Dominica" },
  { label: "Dominican Republic", value: "Dominican Republic" },
  { label: "Ecuador", value: "Ecuador" },
  { label: "Egypt", value: "Egypt" },
  { label: "El Salvador", value: "El Salvador" },
  { label: "Equatorial Guinea", value: "Equatorial Guinea" },
  { label: "Eritrea", value: "Eritrea" },
  { label: "Estonia", value: "Estonia" },
  { label: "Eswatini", value: "Eswatini" },
  { label: "Ethiopia", value: "Ethiopia" },
  { label: "Fiji", value: "Fiji" },
  { label: "Finland", value: "Finland" },
  { label: "France", value: "France" },
  { label: "Gabon", value: "Gabon" },
  { label: "Gambia", value: "Gambia" },
  { label: "Georgia", value: "Georgia" },
  { label: "Germany", value: "Germany" },
  { label: "Ghana", value: "Ghana" },
  { label: "Greece", value: "Greece" },
  { label: "Grenada", value: "Grenada" },
  { label: "Guatemala", value: "Guatemala" },
  { label: "Guinea", value: "Guinea" },
  { label: "Guinea-Bissau", value: "Guinea-Bissau" },
  { label: "Guyana", value: "Guyana" },
  { label: "Haiti", value: "Haiti" },
  { label: "Honduras", value: "Honduras" },
  { label: "Hungary", value: "Hungary" },
  { label: "Iceland", value: "Iceland" },
  { label: "India", value: "India" },
  { label: "Indonesia", value: "Indonesia" },
  { label: "Iran", value: "Iran" },
  { label: "Iraq", value: "Iraq" },
  { label: "Ireland", value: "Ireland" },
  { label: "Israel", value: "Israel" },
  { label: "Italy", value: "Italy" },
  { label: "Jamaica", value: "Jamaica" },
  { label: "Japan", value: "Japan" },
  { label: "Jordan", value: "Jordan" },
  { label: "Kazakhstan", value: "Kazakhstan" },
  { label: "Kenya", value: "Kenya" },
  { label: "Kiribati", value: "Kiribati" },
  { label: "Kuwait", value: "Kuwait" },
  { label: "Kyrgyzstan", value: "Kyrgyzstan" },
  { label: "Laos", value: "Laos" },
  { label: "Latvia", value: "Latvia" },
  { label: "Lebanon", value: "Lebanon" },
  { label: "Lesotho", value: "Lesotho" },
  { label: "Liberia", value: "Liberia" },
  { label: "Libya", value: "Libya" },
  { label: "Liechtenstein", value: "Liechtenstein" },
  { label: "Lithuania", value: "Lithuania" },
  { label: "Luxembourg", value: "Luxembourg" },
  { label: "Madagascar", value: "Madagascar" },
  { label: "Malawi", value: "Malawi" },
  { label: "Malaysia", value: "Malaysia" },
  { label: "Maldives", value: "Maldives" },
  { label: "Mali", value: "Mali" },
  { label: "Malta", value: "Malta" },
  { label: "Marshall Islands", value: "Marshall Islands" },
  { label: "Mauritania", value: "Mauritania" },
  { label: "Mauritius", value: "Mauritius" },
  { label: "Mexico", value: "Mexico" },
  { label: "Micronesia", value: "Micronesia" },
  { label: "Moldova", value: "Moldova" },
  { label: "Monaco", value: "Monaco" },
  { label: "Mongolia", value: "Mongolia" },
  { label: "Montenegro", value: "Montenegro" },
  { label: "Morocco", value: "Morocco" },
  { label: "Mozambique", value: "Mozambique" },
  { label: "Myanmar", value: "Myanmar" },
  { label: "Namibia", value: "Namibia" },
  { label: "Nauru", value: "Nauru" },
  { label: "Nepal", value: "Nepal" },
  { label: "Netherlands", value: "Netherlands" },
  { label: "New Zealand", value: "New Zealand" },
  { label: "Nicaragua", value: "Nicaragua" },
  { label: "Niger", value: "Niger" },
  { label: "Nigeria", value: "Nigeria" },
  { label: "North Korea", value: "North Korea" },
  { label: "North Macedonia", value: "North Macedonia" },
  { label: "Norway", value: "Norway" },
  { label: "Oman", value: "Oman" },
  { label: "Pakistan", value: "Pakistan" },
  { label: "Palau", value: "Palau" },
  { label: "Palestine", value: "Palestine" },
  { label: "Panama", value: "Panama" },
  { label: "Papua New Guinea", value: "Papua New Guinea" },
  { label: "Paraguay", value: "Paraguay" },
  { label: "Peru", value: "Peru" },
  { label: "Philippines", value: "Philippines" },
  { label: "Poland", value: "Poland" },
  { label: "Portugal", value: "Portugal" },
  { label: "Qatar", value: "Qatar" },
  { label: "Romania", value: "Romania" },
  { label: "Russia", value: "Russia" },
  { label: "Rwanda", value: "Rwanda" },
  { label: "Saint Kitts and Nevis", value: "Saint Kitts and Nevis" },
  { label: "Saint Lucia", value: "Saint Lucia" },
  { label: "Saint Vincent and the Grenadines", value: "Saint Vincent and the Grenadines" },
  { label: "Samoa", value: "Samoa" },
  { label: "San Marino", value: "San Marino" },
  { label: "Sao Tome and Principe", value: "Sao Tome and Principe" },
  { label: "Saudi Arabia", value: "Saudi Arabia" },
  { label: "Senegal", value: "Senegal" },
  { label: "Serbia", value: "Serbia" },
  { label: "Seychelles", value: "Seychelles" },
  { label: "Sierra Leone", value: "Sierra Leone" },
  { label: "Singapore", value: "Singapore" },
  { label: "Slovakia", value: "Slovakia" },
  { label: "Slovenia", value: "Slovenia" },
  { label: "Solomon Islands", value: "Solomon Islands" },
  { label: "Somalia", value: "Somalia" },
  { label: "South Africa", value: "South Africa" },
  { label: "South Korea", value: "South Korea" },
  { label: "South Sudan", value: "South Sudan" },
  { label: "Spain", value: "Spain" },
  { label: "Sri Lanka", value: "Sri Lanka" },
  { label: "Sudan", value: "Sudan" },
  { label: "Suriname", value: "Suriname" },
  { label: "Sweden", value: "Sweden" },
  { label: "Switzerland", value: "Switzerland" },
  { label: "Syria", value: "Syria" },
  { label: "Taiwan", value: "Taiwan" },
  { label: "Tajikistan", value: "Tajikistan" },
  { label: "Tanzania", value: "Tanzania" },
  { label: "Thailand", value: "Thailand" },
  { label: "Timor-Leste", value: "Timor-Leste" },
  { label: "Togo", value: "Togo" },
  { label: "Tonga", value: "Tonga" },
  { label: "Trinidad and Tobago", value: "Trinidad and Tobago" },
  { label: "Tunisia", value: "Tunisia" },
  { label: "Turkey", value: "Turkey" },
  { label: "Turkmenistan", value: "Turkmenistan" },
  { label: "Tuvalu", value: "Tuvalu" },
  { label: "Uganda", value: "Uganda" },
  { label: "Ukraine", value: "Ukraine" },
  { label: "United Arab Emirates", value: "United Arab Emirates" },
  { label: "United Kingdom", value: "United Kingdom" },
  { label: "United States", value: "United States" },
  { label: "Uruguay", value: "Uruguay" },
  { label: "Uzbekistan", value: "Uzbekistan" },
  { label: "Vanuatu", value: "Vanuatu" },
  { label: "Vatican City", value: "Vatican City" },
  { label: "Venezuela", value: "Venezuela" },
  { label: "Vietnam", value: "Vietnam" },
  { label: "Yemen", value: "Yemen" },
  { label: "Zambia", value: "Zambia" },
  { label: "Zimbabwe", value: "Zimbabwe" }
];

// ── Read-only / Editable field ───────────────────────────────────────────────
const Field = ({ label, value, name, editing, onChange }) => (
  <div>
    <label className="block font-semibold text-gray-500 mb-1">{label}</label>
    <input
      type="text"
      value={value || ""}
      name={name}
      readOnly={!editing}
      onChange={onChange}
      className={`w-full px-2 py-2 border-b focus:outline-none bg-transparent transition-colors ${editing ? "border-[#06513D]" : "border-gray-300"
        }`}
    />
  </div>
);

const DocumentField = ({ label, doc, docKey, customerId, editing, onUploadSuccess, number, onNumberChange, numberName, onFileSelect }) => {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [uploadMsg, setUploadMsg] = useState("");
  const [selectedFileName, setSelectedFileName] = useState("");

  const baseUrl = (process.env.REACT_APP_API_URL || "http://localhost:8081").replace(/\/$/, "");
  const fullUrl = doc?.filePath
    ? doc.filePath.startsWith("http")
      ? doc.filePath
      : `${baseUrl}/${doc.filePath.replace(/^\//, "")}`
    : null;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSelectedFileName(file.name);
    // Notify parent about the selected file
    onFileSelect && onFileSelect(file);
    setUploadMsg("File selected. Click Save.");
  };

  return (
    <div>
      <label className="block font-semibold text-gray-500 mb-1">{label}</label>
      <div className="flex gap-2 items-center">
        {/* Number field */}
        <input
          type="text"
          value={number || ""}
          name={numberName}
          onChange={onNumberChange}
          readOnly={!editing}
          placeholder={`Enter ${label}`}
          className={`flex-1 px-2 py-2 border-b focus:outline-none bg-transparent min-w-0 transition-colors ${editing ? "border-[#06513D]" : "border-gray-300"}`}
        />

        {/* VIEW button */}
        {fullUrl ? (
          <Button
            type="primary"
            className="bg-[#06513D] text-white text-[10px] h-8 px-3 rounded-md shrink-0"
            onClick={() => window.open(fullUrl, "_blank")}
          >
            VIEW
          </Button>
        ) : (
          <span className="text-gray-400 text-[10px] whitespace-nowrap shrink-0">No file</span>
        )}

        {/* UPLOAD button */}
        {editing && (
          <>
            <input
              type="file"
              ref={fileRef}
              className="hidden"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={handleFileChange}
            />
            <Button
              type="default"
              loading={uploading}
              className="text-[#06513D] border-[#06513D] text-[10px] h-8 px-3 rounded-md shrink-0"
              onClick={() => fileRef.current?.click()}
            >
              {uploading ? "..." : "UPLOAD"}
            </Button>
          </>
        )}
      </div>

      {/* File name preview and status */}
      {selectedFileName && (
        <p className="text-[10px] text-gray-500 mt-1 truncate">Selected: {selectedFileName}</p>
      )}
      {uploadMsg && (
        <p className={`text-[10px] mt-1 ${uploadMsg.includes("selected") ? "text-[#06513D]" : "text-red-500"}`}>
          {uploadMsg}
        </p>
      )}
    </div>
  );
};

// ── Main Component ────────────────────────────────────────────────────────────
const OrganizationDetails = ({ isEditing, organizationDetails, contactDetails, handleOrgChange, handleBillingChange, handleOrgFileSelect }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { currentCustomer } = useSelector((state) => state.customer);

  const customerId = location.state?.userId || currentCustomer?._id;

  const org = currentCustomer?.organization || {};
  const orgAddr = org.address || {};

  const [popup, setPopup] = useState({ visible: false, type: "success", title: "", message: "" });

  // No local state sync needed, using props now.
  const form = organizationDetails || {};
  const handleChange = handleOrgChange;

  const showPopup = (type, title, message) => {
    setPopup({ visible: true, type, title, message });
    setTimeout(() => setPopup((p) => ({ ...p, visible: false })), 3000);
  };

  const handleUploadSuccess = () => {
    if (customerId) dispatch(fetchCustomerById(customerId));
  };

  const handleSave = async () => {
    if (!customerId) return;
    const formData = new FormData();

    // Organization Info
    formData.append("orgName", form.org_name);
    formData.append("orgNatureOfBusiness", form.org_natureOfBusiness);
    formData.append("orgAddressCity", form.org_city);
    formData.append("orgAddressState", form.org_state);
    formData.append("orgAddressPinCode", form.org_pinCode);
    formData.append("orgAddressCountry", form.org_country);

    // Organization Documents - Numbers
    formData.append("orgCinNumber", form.org_cin_number);
    formData.append("orgPanNumber", form.org_pan_number);
    formData.append("orgVatNumber", form.org_vat_number);
    formData.append("orgDunsNumber", form.org_duns_number);

    // Organization Documents - Files (only if selected)
    if (form.org_cin_file) formData.append("orgCinFile", form.org_cin_file);
    if (form.org_pan_file) formData.append("orgPanFile", form.org_pan_file);
    if (form.org_vat_file) formData.append("orgVatFile", form.org_vat_file);
    if (form.org_duns_file) formData.append("orgDunsFile", form.org_duns_file);

    // Billing Info
    formData.append("billing[organizationName]", form.billing_organizationName);
    formData.append("billing[contactPersonName]", form.billing_contactPersonName);
    formData.append("billing[email]", form.billing_email);
    formData.append("billing[countryCode]", form.billing_countryCode);
    formData.append("billing[contactNumber]", form.billing_contactNumber);
    formData.append("billing[address][city]", form.billing_city);
    formData.append("billing[address][state]", form.billing_state);
    formData.append("billing[address][pinCode]", form.billing_pinCode);
    formData.append("billing[address][country]", form.billing_country);

    const result = await dispatch(updateCustomerProfile({ id: customerId, data: formData }));
    if (updateCustomerProfile.fulfilled.match(result)) {
      showPopup("success", "Success", "Organization & Billing details updated successfully");
      dispatch(fetchCustomerById(customerId)); // Refresh data
    } else {
      showPopup("error", "Error", result.payload || "Failed to update details");
    }
  };

  return (
    <div className="bg-white py-4 relative">
      <div className="flex justify-between items-center mb-4">
        <h4 className="text-xl font-semibold text-[#06513D]">Organization Details</h4>
      </div>

      <div className="mb-6">
        <div className="grid grid-cols-2 gap-6 mb-4">
          <Field label="Organization Name" value={form.name} name="name" editing={isEditing} onChange={handleChange} />
          <Field label="Nature of Business" value={form.natureOfBusiness} name="natureOfBusiness" editing={isEditing} onChange={handleChange} />
        </div>

        <label className="block font-semibold text-gray-500 mb-2">Organization Address</label>
        <div className="grid grid-cols-2 gap-6 mb-4">
          <Field label="City" value={form.address?.city} name="address.city" editing={isEditing} onChange={handleChange} />
          <Field label="State" value={form.address?.state} name="address.state" editing={isEditing} onChange={handleChange} />
          <Field label="Pin Code" value={form.address?.pinCode} name="address.pinCode" editing={isEditing} onChange={handleChange} />
          <div>
            <label className="block font-semibold text-gray-500 mb-1">Country</label>
            <select
              name="address.country"
              value={form.address?.country}
              disabled={!isEditing}
              onChange={handleChange}
              className={`w-full pr-3 py-2 border-b focus:outline-none bg-transparent transition-colors ${isEditing ? "border-[#06513D]" : "border-gray-300"}`}
            >
              <option value="">{form.address?.country || "Select a country"}</option>
              {countries.map((c, i) => <option key={i} value={c.value}>{c.label}</option>)}
            </select>
          </div>
        </div>

        <label className="block font-semibold text-gray-500 mb-2 mt-2">Organization Documents</label>
        <div className="grid grid-cols-2 gap-6 mb-4">
          <DocumentField
            label="CIN Number"
            doc={org.cin}
            docKey="cin"
            customerId={customerId}
            editing={isEditing}
            onUploadSuccess={handleUploadSuccess}
            number={form.cin?.number}
            numberName="cin"
            onNumberChange={handleChange}
            onFileSelect={(file) => handleOrgFileSelect("cin", file)}
          />
          <DocumentField
            label="PAN Number"
            doc={org.pan}
            docKey="pan"
            customerId={customerId}
            editing={isEditing}
            onUploadSuccess={handleUploadSuccess}
            number={form.pan?.number}
            numberName="pan"
            onNumberChange={handleChange}
            onFileSelect={(file) => handleOrgFileSelect("pan", file)}
          />
          <DocumentField
            label="VAT Number"
            doc={org.vat}
            docKey="vat"
            customerId={customerId}
            editing={isEditing}
            onUploadSuccess={handleUploadSuccess}
            number={form.vat?.number}
            numberName="vat"
            onNumberChange={handleChange}
            onFileSelect={(file) => handleOrgFileSelect("vat", file)}
          />
          <DocumentField
            label="DUNS Number"
            doc={org.duns}
            docKey="duns"
            customerId={customerId}
            editing={isEditing}
            onUploadSuccess={handleUploadSuccess}
            number={form.duns?.number}
            numberName="duns"
            onNumberChange={handleChange}
            onFileSelect={(file) => handleOrgFileSelect("duns", file)}
          />
        </div>
      </div>

      <div className="border-t pt-6">
        <h4 className="text-xl font-semibold text-[#06513D] mb-4">Billing Information</h4>
        <div className="grid grid-cols-2 gap-6 mb-4">
          <Field label="Organization Name" value={contactDetails.organizationName} name="organizationName" editing={isEditing} onChange={handleBillingChange} />
          <Field label="Contact Person Name" value={contactDetails.contactPersonName} name="contactPersonName" editing={isEditing} onChange={handleBillingChange} />
          <Field label="Email" value={contactDetails.email} name="email" editing={isEditing} onChange={handleBillingChange} />
          <div className="flex gap-2">
            <div className="w-28">
              <Field label="Country Code" value={contactDetails.countryCode} name="countryCode" editing={isEditing} onChange={handleBillingChange} />
            </div>
            <div className="flex-1">
              <Field label="Contact Number" value={contactDetails.contactNumber} name="contactNumber" editing={isEditing} onChange={handleBillingChange} />
            </div>
          </div>
          <Field label="Billing Contact Person Name" value={contactDetails.billingContact?.contactPersonName} name="billingContact.contactPersonName" editing={isEditing} onChange={handleBillingChange} />
          <Field label="Billing Contact Number" value={contactDetails.billingContact?.contactNumber} name="billingContact.contactNumber" editing={isEditing} onChange={handleBillingChange} />
        </div>

        <label className="block font-semibold text-gray-500 mb-2">Billing Address</label>
        <div className="grid grid-cols-2 gap-6">
          <Field label="City" value={contactDetails.address?.city} name="address.city" editing={isEditing} onChange={handleBillingChange} />
          <Field label="State" value={contactDetails.address?.state} name="address.state" editing={isEditing} onChange={handleBillingChange} />
          <Field label="Pin Code" value={contactDetails.address?.pinCode} name="address.pinCode" editing={isEditing} onChange={handleBillingChange} />
          <div>
            <label className="block font-semibold text-gray-500 mb-1">Country</label>
            <select
              name="address.country"
              value={contactDetails.address?.country}
              disabled={!isEditing}
              onChange={handleBillingChange}
              className={`w-full pr-3 py-2 border-b focus:outline-none bg-transparent transition-colors ${isEditing ? "border-[#06513D]" : "border-gray-300"}`}
            >
              <option value="">{contactDetails.address?.country || "Select a country"}</option>
              {countries.map((c, i) => <option key={i} value={c.value}>{c.label}</option>)}
            </select>
          </div>
        </div>
      </div>

      {/* {isEditing && (
        <div className="flex justify-end mt-6">
          <button
            onClick={handleSave}
            className="px-8 py-2 rounded-md bg-[#06513D] text-white font-semibold hover:bg-[#054031] transition-colors shadow-md"
          >
            Save Organization & Billing
          </button>
        </div>
      )} */}

      {popup.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type={popup.type}
            title={popup.title}
            message={popup.message}
            onClose={() => setPopup((p) => ({ ...p, visible: false }))}
          />
        </div>
      )}
    </div>
  );
};

export default OrganizationDetails;
